// TOTP (RFC 6238, sobre HOTP RFC 4226) con los defaults estándar que ya
// asume src/components/QRGenerator.vue al armar la URI otpauth:// (SHA-1,
// 6 dígitos, período de 30s) — sin params explícitos en la URI, cualquier
// authenticator app los interpreta con esos defaults, así que el backend
// tiene que estar generando el secret para esos mismos parámetros.

const BASE32_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';

function base32Decode(base32) {
    const clean = base32.toUpperCase().replace(/[^A-Z2-7]/g, '');
    let bits = '';
    for (const char of clean) {
        const value = BASE32_ALPHABET.indexOf(char);
        if (value === -1) continue;
        bits += value.toString(2).padStart(5, '0');
    }
    const bytes = [];
    for (let i = 0; i + 8 <= bits.length; i += 8) {
        bytes.push(parseInt(bits.substring(i, i + 8), 2));
    }
    return new Uint8Array(bytes);
}

export async function computeTotp(base32Secret, { digits = 6, period = 30, at = Date.now() } = {}) {
    const keyBytes = base32Decode(base32Secret);
    const counter = Math.floor(at / 1000 / period);

    const counterBuffer = new ArrayBuffer(8);
    const counterView = new DataView(counterBuffer);
    counterView.setUint32(0, Math.floor(counter / 2 ** 32));
    counterView.setUint32(4, counter >>> 0);

    const key = await crypto.subtle.importKey('raw', keyBytes, { name: 'HMAC', hash: 'SHA-1' }, false, ['sign']);
    const signature = await crypto.subtle.sign('HMAC', key, counterBuffer);
    const hmacBytes = new Uint8Array(signature);

    const offset = hmacBytes[hmacBytes.length - 1] & 0x0f;
    const code = ((hmacBytes[offset] & 0x7f) << 24)
        | ((hmacBytes[offset + 1] & 0xff) << 16)
        | ((hmacBytes[offset + 2] & 0xff) << 8)
        | (hmacBytes[offset + 3] & 0xff);

    return String(code % (10 ** digits)).padStart(digits, '0');
}
